import React, { useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, CircularProgress, Typography, Alert, Link } from "@mui/material";
import { AuthContext } from "context/Auth";
import SchedulerComponent from "components/scheduler/SchedulerComponent";
import PremiumAlert from "components/dashboard/PremiumAlert";
import PremiumWrapper from "components/dashboard/PremiumWrapper";

const SchedulerPage = ({ data }) => {
  const { subscription, userData, userLoading } = useContext(AuthContext);

  // Get facility status using the new string-based enum
  const facilityStatus = data?.status || "approved";
  const isNotApproved = facilityStatus !== "approved";

  return (
    <div className="inner">
      <Typography
        variant="h4"
        component="h2"
        sx={{ mt: { xs: 1, sm: 5 }, mb: 2 }}
      >
        Wait Time Scheduler
      </Typography>

      <Typography variant="body" sx={{ display: "block", mt: 1, mb: 4 }}>
        Schedule your facility's wait times in advance to keep patients informed
        without requiring constant updates. Set expected wait times for
        different times of day.
      </Typography>

      {!data?.id ? (
        <CircularProgress />
      ) : (
        <Box>
          {!subscription && <PremiumAlert feature="Wait time scheduling" />}

          {isNotApproved && (
            <Alert
              severity={facilityStatus === "pending" ? "warning" : "error"}
              sx={{ mb: 4 }}
            >
              {facilityStatus === "pending"
                ? "Scheduling is disabled until your facility is approved. This usually takes 1-2 days."
                : "Your facility has been rejected. Scheduling is disabled."}
            </Alert>
          )}

          {data?.queueEnabled === false && (
            <Alert severity="info" sx={{ mb: 3 }}>
              To get the most out of scheduling, enable your{" "}
              <Link component={RouterLink} to="/dashboard/waiting-room">
                Virtual Waiting Room
              </Link>{" "}
              first.
            </Alert>
          )}

          <PremiumWrapper disabled={!subscription}>
            <SchedulerComponent data={data} previewMode={!subscription} />
          </PremiumWrapper>
        </Box>
      )}
    </div>
  );
};

export default SchedulerPage;
